const Pathway = {
  DIGITAL: "Digital",
  SUPPORTED: "Supported",
};

export default Pathway;
